import ContentfulSection from '../ContentfulSection';

const PageUnauthenticatedView = ({ sections }) =>
  sections.map(
    (props: any) => props && <ContentfulSection key={`${props?.type ?? 'section'}-${props?.id}`} {...props} />
  );

export default PageUnauthenticatedView;
